import {throwIfNull} from '@coolcolduk/util';
import clarity from '@microsoft/clarity';
import {env} from '../env/getEnvVar';

let clarityInstance: typeof clarity | null = null;

/**
 * Get Clarity instance using singleton pattern
 * @returns Clarity instance or null if not initialized
 */
export function getClarity(): typeof clarity {
  // init if not initialized
  if (!clarityInstance) {
    try {
      clarity.init(env.clarityProjectId);
      clarityInstance = clarity;
    } catch (error) {
      console.warn('Error initializing Microsoft Clarity:', error);
      throw error;
    }
  }
  return throwIfNull(clarityInstance, 'Clarity instance not initialized');
}
